import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M10.33 19.5h3.33V22h-3.33zM16.86 3.57A7.12 7.12 0 0012 2a7 7 0 00-4.58 1.46 6.34 6.34 0 00-2.09 4.22L7.94 8a5 5 0 011.42-3 4 4 0 012.71-1 4 4 0 012.83 1.05 3.29 3.29 0 011.16 2.48 2.73 2.73 0 01-.4 1.47A8.22 8.22 0 0114 10.73a18.08 18.08 0 00-1.82 1.68 5.47 5.47 0 00-1 1.57 6.08 6.08 0 00-.42 2.37V17h2.43a8.69 8.69 0 01.22-2 3.18 3.18 0 01.56-1.1 12.17 12.17 0 011.62-1.53A11.14 11.14 0 0018 9.73a4.63 4.63 0 00.64-2.37 4.87 4.87 0 00-1.78-3.79z"
      fill="fj-icons-primary-color"
    />
  </svg>
);

const HelpNoCircle = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default HelpNoCircle;
